<icc-list [searchable]="true" [items]="glazingSpacers"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectSpacer($event)"></icc-list>
